<div class="card mb-5">
	<div class="card-header">
		<h3>Bolsa de Facturas</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="startDate" class="form-label">Fecha Inicio:</label>
						<input type="date" id="startDate" (change)="getInvoiceBag()" name="startDate"
							[(ngModel)]="startDate" [max]="endDate" class="form-control">
					</div>
					<div class="col-sm form-group">
						<label for="endDate" class="form-label">Fecha Fin:</label>
						<input type="date" id="endDate" (change)="getInvoiceBag()" name="endDate" [(ngModel)]="endDate"
							[min]="startDate" class="form-control">
					</div>
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar por serie o número</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="search"
								placeholder="Ingresa serie o numero" name="filterVendors" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
				<ng-container *ngIf="!gettingData">
					<div class="table-responsive mt-2" [class.table-responsive-without]="waitingFor && !seeingAnulate"
						style="margin-bottom: 0;">
						<table class="table table-bordered" style="margin-bottom: 0;">
							<thead>
								<tr class="tr-middle">
									<th>
										Bodega
									</th>
									<th>
										Recibo Serie
									</th>
									<th>
										Recibo Número
									</th>
									<th>
										Serie
									</th>
									<th>
										Número
									</th>
									<th>
										Fecha
									</th>
									<th>
										Recibo Total
									</th>
									<th>
										Total
									</th>
									<th>

									</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let invoice of pagination.filter">
									<tr class="tr-middle invoice-backend" [class.rollback]="invoice.status"
										[class.hide-all]="waitingFor?.id==invoice.id">
										<td>
											{{invoice.factWarehouse}}
										</td>
										<td>
											{{invoice.reciboSerie}}
										</td>
										<td>
											{{invoice.reciboNumero}}
										</td>
										<td>
											{{invoice.factSerie}}
										</td>
										<td>
											{{invoice.factNumero}}
										</td>
										<td>
											{{invoice.factDate | date: 'dd/MM/YYYY'}}
										</td>
										<td>
											{{invoice.reciboTotal | currency: 'Q'}}
										</td>
										<td>
											{{invoice.factTotal | currency: 'Q'}}
										</td>
										<td>
											<div *ngIf="invoice.status == 0"
												style="display: flex; justify-content: space-around;">
												<span (click)="downloadReceipt(invoice)" tooltip="Recibo">
													<i *ngIf="!downloading[invoice.id]"
														class="clickeable text-info fa fa-receipt"></i>
													<span *ngIf="downloading[invoice.id]"
														class="text-info spinner-border spinner-border-sm"></span>
												</span>
												<span (click)="downloadInvoice(invoice)" tooltip="Factura">
													<i *ngIf="!downloadingInvoice[invoice.id]"
														class="clickeable text-info fa fa-file-invoice-dollar"></i>
													<span *ngIf="downloadingInvoice[invoice.id]"
														class="text-info spinner-border spinner-border-sm"></span>
												</span>
												<div class="container-superposition">
													<div class="element-superposition"
														*ngIf="waitingFor?.id == invoice.id && reinvoice">
														<span>¿Está seguro que desea refacturar?</span>
														<span class="a-container">
															<span class="a-hover" (click)="resetDeletingDiv()"><i
																	class="fa fa-xmark"></i>NO</span>
															<span class="a-hover text-danger"
																(click)="confirmReinvoice(invoice)"><i
																	class="fa fa-arrows-rotate"></i>SÍ</span>
														</span>
													</div>
													<span class="clickeable text-danger"
														(click)="assignTo(invoice, true)" tooltip="Refacturar"
														#tooltip="bs-tooltip">
														<i *ngIf="!reinvoicing[invoice.id]"
															class="fa fa-arrows-rotate"></i>
														<app-loading-animation *ngIf="reinvoicing[invoice.id]"
															[height]="'1rem'" [color]="'red'"></app-loading-animation>
													</span>
												</div>
												<div class="container-superposition">
													<div class="element-superposition"
														*ngIf="waitingFor?.id == invoice.id && !reinvoice">
														<span>¿Está seguro que desea anular?</span>
														<span class="a-container">
															<span class="a-hover" (click)="resetDeletingDiv()"><i
																	class="fa fa-xmark"></i>NO</span>
															<span class="a-hover text-danger"
																(click)="confirmAnulate(invoice)"><i
																	class="fa fa-ban"></i>SÍ</span>
														</span>
													</div>
													<span class="clickeable text-danger" tooltip="Anular"
														#tooltip="bs-tooltip" (click)="assignTo(invoice, false)">
														<i *ngIf="!deleting[invoice.id]" class="fa fa-ban"></i>
														<app-loading-animation [height]="'1rem'" *ngIf="deleting[invoice.id]"
															[color]="'red'"></app-loading-animation>
													</span>
												</div>
											</div>
										</td>
									</tr>
								</ng-container>
								<tr class="tr-middle" *ngIf="pagination.filter.length == 0">
									<td colspan="9" style="color: gray">
										<i class="fa fa-circle-info"></i>No se encontraron facturas en las fechas
										seleccionadas
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<app-pagination-custom [elements]="pagination"></app-pagination-custom>
				</ng-container>
				<app-loading-animation *ngIf="gettingData" [height]="'10rem'"></app-loading-animation>
			</div>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="waitingFor">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
</div>